import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "William Johnson",
        title: "Founder & CEO",
        biography: "William Johnson is the visionary Founder and CEO of our Water Delivery Company. With a passion for clean, accessible water and over a decade of leadership experience, he has built the company on the values of reliability, sustainability, and customer care. William’s mission is to ensure every household and business has access to safe drinking water. Under his guidance, the company has grown into a trusted name in water solutions.",
        contacts: {
            phone: "222-333-4455",
            email: "william.johnson@example.com",
            address: "456 Aqua Street, Suite 101, HydroCity, ST 67890",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Water Purification Expert",
            "Logistics & Distribution Manager",
            "Hydration Solutions Consultant",
            "Business Development Strategist",
            "Founder & CEO"
        ],
        skills: [
            { id: 1, title: "Water Delivery Management", progress: 95 },
            { id: 2, title: "Logistics & Operations", progress: 92 },
            { id: 3, title: "Customer Service Leadership", progress: 90 },
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Amelia Taylor",
        title: "Operations Manager",
        biography: "Amelia Taylor is a results-driven Operations Manager dedicated to ensuring the smooth and efficient functioning of our water delivery services. With strong leadership and problem-solving skills, she oversees daily operations, coordinates delivery routes, and ensures timely customer service. Her expertise in logistics and operational strategy plays a vital role in maintaining our commitment to excellence.",
        contacts: {
            phone: "333-444-5566",
            email: "amelia.taylor@example.com",
            address: "789 Flow Avenue, Suite 202, HydroCity, ST 67890",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Fleet & Route Coordinator",
            "Customer Relations Supervisor",
            "Water Delivery Scheduler",
            "Inventory & Supply Chain Analyst",
            "Operations Manager"
        ],
        skills: [
            { id: 1, title: "Operations Management", progress: 93 },
            { id: 2, title: "Logistics Coordination", progress: 90 },
            { id: 3, title: "Team Supervision", progress: 88 },
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "David Wilson",
        title: "Delivery Driver",
        biography: "David Wilson is a dependable and customer-focused Delivery Driver known for his punctuality and professionalism. He ensures that water deliveries are made safely, efficiently, and on time to homes and businesses. With excellent route knowledge and a commitment to customer satisfaction, David plays a key role in upholding the company’s trusted reputation.",
        contacts: {
            phone: "444-555-6677",
            email: "david.wilson@example.com",
            address: "321 Streamline Blvd, Apt 5C, HydroCity, ST 67890",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Licensed Commercial Driver",
            "Route Delivery Specialist",
            "Customer Interaction Expert",
            "Vehicle Maintenance Handler",
            "Delivery Driver"
        ],
        skills: [
            { id: 1, title: "Safe Driving & Navigation", progress: 95 },
            { id: 2, title: "Time Management", progress: 92 },
            { id: 3, title: "Customer Service", progress: 90 },
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Elizabeth Scott",
        title: "Marketing Manager",
        biography: "Elizabeth Scott is a creative and strategic Marketing Manager with a passion for building brand visibility and customer engagement. She leads campaigns that highlight our commitment to clean water and reliable service. Through a mix of digital and traditional marketing efforts, Elizabeth ensures our message reaches the right audience and drives growth across all channels.",
        contacts: {
            phone: "555-666-7788",
            email: "elizabeth.scott@example.com",
            address: "987 Clearview Drive, Suite 303, HydroCity, ST 67890",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Brand Strategist",
            "Digital Marketing Specialist",
            "Advertising Coordinator",
            "Content & Campaign Developer",
            "Marketing Manager"
        ],
        skills: [
            { id: 1, title: "Brand Marketing", progress: 94 },
            { id: 2, title: "Social Media Strategy", progress: 91 },
            { id: 3, title: "Customer Engagement", progress: 89 },
        ]
    }

];

export default team;